import React, { useState } from "react";

import { SearchSupplierEmpComponent } from "./search-component/SearchSupplierEmp";
import { useContextProvider } from "./ContextProvider";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  DialogContentText,
  Grid,
  FormControl,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
// import { ReactComponent as ExcelIcon } from "@deere/ux.brand-foundations/icons/excel.svg";
import { SupplierSetupTable } from "./supplier-setup-table/SupplierSetupTable";
import { MainCategoriesMenu } from "./categories-component/CategoriesMenu";
import { downloadFile } from "./utils";
import As2TPDetails from "../as2-tp-details-component/As2TPDetails";

export const MainView = () => {
  const { userType, errorWindowOpen, setErrorWindowOpen, gridTPData } =
    useContextProvider();
  const [selectedTP, setSelectedTP] = useState({
    envelope: undefined,
  });
  let search;

  if (userType !== "Supplier Employee") {
    search = <SearchSupplierEmpComponent />;
  }

  const exportToCSV = (e) => {
    e.preventDefault();

    const headers = [
      "Supplier,Supplier Description,EDI Unit,Unit,Unit Name,EDI Type,SAP Number,Transaction,Version,Direction,T/P Flag,ISA Qualifier,ISA ID,GS ID,Last ISA Date,Last ISA Cntl #,Last GS Date,Last GS Cntl,Last Tran Cntl,Envelope",
    ];

    let tpDataCSV = gridTPData.reduce((acc, entry) => {
      const {
        supplier,
        supplier_name,
        unit,
        unit_key,
        unit_name,
        supplier_type,
        sap_partner_number,
        transaction,
        version,
        direction,
        tp_flag,
        isa_qualifier,
        isa_id,
        gs_id,
        last_isa_date,
        last_isa_cntrlnum,
        last_gs_date,
        last_grp_cntrlnum,
        last_tran_cntrlnum,
        envelope,
      } = entry;

      acc.push(
        [
          supplier,
          supplier_name,
          unit,
          unit_key,
          unit_name,
          supplier_type,
          sap_partner_number,
          transaction,
          version,
          direction,
          tp_flag,
          isa_qualifier,
          isa_id,
          gs_id,
          last_isa_date,
          last_isa_cntrlnum,
          last_gs_date,
          last_grp_cntrlnum,
          last_tran_cntrlnum,
          envelope,
        ].join(",")
      );
      return acc;
    }, []);

    downloadFile({
      data: [...headers, ...tpDataCSV].join("\n"),
      fileName: "EDI Setup Details.csv",
      fileType: "text/csv",
    });
  };

  const handleClose = () => {
    setErrorWindowOpen(false);
  };
  return (
    <div style={{ textAlign: "left" }}>
      <Dialog
        open={errorWindowOpen}
        onClose={handleClose}
        aria-labelledby="alert-Modal-title"
        aria-describedby="alert-Modal-description"
      >
        <DialogTitle id="alert-Modal-title">Unexpected Error</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-Modal-description">
            An error was ocurred,please try again. If the error persists,
            contact Administator.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Box maxWidth="100%">
        <Grid container spacing={6}>
          <Grid
            container
            item
            size={{ xs:6, md:6, lg:10, xl:10}}
            alignItems="flex-start"
          >
            <Typography gutterBottom variant="h1" component="h1">
              EDI Supplier Setup Details
            </Typography>
          </Grid>
          <Grid
            container
            item
            size={{ xs:6, md:6, lg:2, xl:2}}
            justifyContent={"flex-end"}
          >
            <Button
              style={{ 
                    borderColor:"#ebd534",
                    backgroundColor: "#ebd534",
                    color:"black"
                           
                   }}
              href={process.env.REACT_APP_CREA_EDI_SETUP_URL}
              target={"_blank"}
            >
              Request EDI Setup
            </Button>
          </Grid>
        </Grid>

        <Box mt={4}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item size={{ xs:12, sm:4, md:6, lg:8, xl:9}}>
              <FormControl fullWidth>{search}</FormControl>
            </Grid>
            <Grid
              container
              item
              size={{ xs:12, sm:4, md:4, lg:2, xl:2}}
              justifyContent={"flex-start"}
            >             
              <MainCategoriesMenu />
            </Grid>
            <Grid
              container
              item
              size={{ xs:12, sm:4, md:2, lg:2, xl:1}}
              justifyContent={"flex-end"}
            >
              <Button
                variant="link"
                startIcon={<fuel-icon name={"microsoft_excel"} />}
                onClick={exportToCSV}
              >
                Download
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box maxWidth="100%" mt={4} maxHeight="100%">
          <Card square={true}>
            <CardContent divider={"FuelDivider"}>
              <SupplierSetupTable handlerDetails={setSelectedTP} />
            </CardContent>
          </Card>
        </Box>
        <Box maxWidth="100%" mt={4} maxHeight="100%">
          <Card square={true}>
            <CardContent divider={"FuelDivider"}>
              <As2TPDetails
                envelope={selectedTP.envelope}
                supplierNum={selectedTP.supplier}
              />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </div>
  );
};
